import SportsActivitiesPage from './SportsActivities.page';

export default SportsActivitiesPage;
